import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
    color: ${({ theme }) => theme.text};
  background-color: ${({ theme }) => theme.background};
`;

const Section = styled.section`
  margin-bottom: 30px;
`;

const Heading = styled.h2`
  margin-bottom: 15px;
  text-align: center;
`;

const SubHeading = styled.h3`
  color: #555;
  margin-top: 20px;
  margin-bottom: 10px;
  color: ${({ theme }) => theme.headerText};
`;

const Paragraph = styled.p`
  margin-bottom: 10px;
  line-height: 1.6;
`;

const List = styled.ul`
  list-style-type: disc;
  margin-left: 20px;
  margin-bottom: 15px;
`;

const CleanList = styled.ul`
  list-style-type: none; /* This will hide dots */
  margin-left: 20px; /* Adjust as needed, you might want less indent for dotless lists */
  padding-left: 0; /* Important to remove default padding that creates indent */
  margin-bottom: 15px;

  a{
  color: ${({ theme }) => theme.headerText};}
`;

const ListItem = styled.li`
  margin-bottom: 5px;
  
`;

const Strong = styled.strong`
  font-weight: bold;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 15px;
  margin-bottom: 30px;
`;

const Th = styled.th`
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
`;

const Td = styled.td`
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
`;

const Image = styled.img`
  max-width: 100%;
  height: auto;
  display: block;
  margin: 1.5em auto;
  border: 1px solid #ddd;
  box-shadow: 2px 2px 5px rgba(0,0,0,0.1);
`;

// Helper component for displaying the fields in a table
const TemplateFieldsTable = ({ title, fields }) => (
  <Section>
    <SubHeading>{title}</SubHeading>
    <Table>
      <thead>
        <tr>
          <Th>Column #</Th>
          <Th>Classify Field Setup</Th>
          <Th>Target Field Category</Th>
          <Th>Target Column Type</Th>
          <Th>Target Column Name</Th>
          <Th>Source Column Name</Th>
          <Th>Column Not Used</Th>
        </tr>
      </thead>
      <tbody>
        {fields.map((field, index) => (
          <tr key={index}>
            <Td>{field.column_number}</Td>
            <Td>{field.target_column_classify_field_setup}</Td>
            <Td>{field.target_field_category}</Td>
            <Td>{field.target_column_type}</Td>
            <Td>{field.target_column_name}</Td>
            <Td>{field.source_column_name}</Td>
            <Td>{field.column_not_used}</Td>
          </tr>
        ))}
      </tbody>
    </Table>
  </Section>
);


const Cvc2022Content = () => {
  // Data for the Core Template Fields table
  const coreTemplateFields = [
    {
      column_number: 1,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'bigint',
      target_column_name: 'csb_survey_production_lot_id',
      source_column_name: 'csb_survey_production_lot_id',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 2,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'bigint',
      target_column_name: 'csb_survey_main_id',
      source_column_name: 'csb_survey_main_id',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 3,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'bigint',
      target_column_name: 'csb_record_group_id',
      source_column_name: 'csb_record_group_id',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 4,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'bigint',
      target_column_name: 'csb_account_id',
      source_column_name: 'csb_account_id',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 5,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'bigint',
      target_column_name: 'csb_survey_production_lot_upload_id',
      source_column_name: 'csb_survey_production_lot_upload_id',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 6,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'integer',
      target_column_name: 'csb_pl_template_id',
      source_column_name: 'csb_pl_template_id',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 7,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'varchar(128)',
      target_column_name: 'csb_pl_production_lot_code',
      source_column_name: 'feedlot_lot_name',
      column_not_used: 'Used (0)',
    },
    {
      column_number: 8,
      target_column_classify_field_setup: 'Setup Lookup Field (2)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'integer',
      target_column_name: 'csb_pl_sex_id',
      source_column_name: 'sex',
      column_not_used: 'Used (0)',
    },
    {
      column_number: 9,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'numeric',
      target_column_name: 'csb_pl_sex_percent_steers',
      source_column_name: 'csb_pl_sex_percent_steers',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 10,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'numeric',
      target_column_name: 'csb_pl_sex_percent_cows',
      source_column_name: 'csb_pl_sex_percent_cows',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 11,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'numeric',
      target_column_name: 'csb_pl_sex_percent_heifers',
      source_column_name: 'csb_pl_sex_percent_heifers',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 12,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'numeric',
      target_column_name: 'csb_pl_sex_percent_bulls',
      source_column_name: 'csb_pl_sex_percent_bulls',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 13,
      target_column_classify_field_setup: 'Setup Lookup Field (2)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'integer',
      target_column_name: 'csb_pl_animal_age_category_id',
      source_column_name: 'cattle_type',
      column_not_used: 'Used (0)',
    },
    {
      column_number: 14,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'numeric',
      target_column_name: 'csb_pl_percent_calves',
      source_column_name: 'csb_pl_percent_calves',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 15,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'numeric',
      target_column_name: 'csb_pl_percent_yearlings',
      source_column_name: 'csb_pl_percent_yearlings',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 16,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'numeric',
      target_column_name: 'csb_pl_percent_adults',
      source_column_name: 'csb_pl_percent_adults',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 17,
      target_column_classify_field_setup: 'Setup Lookup Field (2)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'integer',
      target_column_name: 'csb_pl_origin_id',
      source_column_name: 'origin',
      column_not_used: 'Used (0)',
    },
    {
      column_number: 18,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'numeric',
      target_column_name: 'csb_pl_origin_percent_auction',
      source_column_name: 'csb_pl_origin_percent_auction',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 19,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'numeric',
      target_column_name: 'csb_pl_origin_percent_backgrounded',
      source_column_name: 'csb_pl_origin_percent_backgrounded',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 20,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'numeric',
      target_column_name: 'csb_pl_origin_percent_ranch_direct',
      source_column_name: 'csb_pl_origin_percent_ranch_direct',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 21,
      target_column_classify_field_setup: 'Setup Lookup Field (2)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'integer',
      target_column_name: 'csb_pl_brd_risk_id',
      source_column_name: 'brd_risk',
      column_not_used: 'Used (0)',
    },
    {
      column_number: 22,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'numeric',
      target_column_name: 'csb_pl_brd_risk_percent_low',
      source_column_name: 'csb_pl_brd_risk_percent_low',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 23,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'numeric',
      target_column_name: 'csb_pl_brd_risk_percent_medium',
      source_column_name: 'csb_pl_brd_risk_percent_medium',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 24,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'numeric',
      target_column_name: 'csb_pl_brd_risk_percent_high',
      source_column_name: 'csb_pl_brd_risk_percent_high',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 25,
      target_column_classify_field_setup: 'Setup Lookup Field (2)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'integer',
      target_column_name: 'csb_pl_quarter_of_year_closeout_id',
      source_column_name: 'closeout_period',
      column_not_used: 'Used (0)',
    },
    {
      column_number: 26,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'integer',
      target_column_name: 'csb_pl_n_animals_in',
      source_column_name: 'hd_in',
      column_not_used: 'Used (0)',
    },
    {
      column_number: 27,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'integer',
      target_column_name: 'csb_pl_n_animals_railed',
      source_column_name: 'csb_pl_n_animals_railed',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 28,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'integer',
      target_column_name: 'csb_pl_n_animals_dead',
      source_column_name: 'deaths',
      column_not_used: 'Used (0)',
    },
    {
      column_number: 29,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'integer',
      target_column_name: 'csb_pl_n_animals_slaughtered',
      source_column_name: 'hd_out',
      column_not_used: 'Used (0)',
    },
    {
      column_number: 30,
      target_column_classify_field_setup: 'Setup Lookup Field (2)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'integer',
      target_column_name: 'csb_pl_source_weight_in_units_id',
      source_column_name: 'csb_pl_source_weight_in_units_id',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 31,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'numeric',
      target_column_name: 'csb_pl_source_weight_in_value',
      source_column_name: 'csb_pl_source_weight_in_value',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 32,
      target_column_classify_field_setup: 'Setup Multiple Target Fields (3)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'numeric',
      target_column_name: 'csb_pl_avg_weight_in_kgs',
      source_column_name: 'avg_wt_in',
      column_not_used: 'Used (0)',
    },
    {
      column_number: 33,
      target_column_classify_field_setup: 'Setup Lookup Field (2)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'integer',
      target_column_name: 'csb_pl_source_weight_out_units_id',
      source_column_name: 'csb_pl_source_weight_out_units_id',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 34,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'numeric',
      target_column_name: 'csb_pl_source_weight_out_value',
      source_column_name: 'csb_pl_source_weight_out_value',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 35,
      target_column_classify_field_setup: 'Setup Multiple Target Fields (3)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'numeric',
      target_column_name: 'csb_pl_avg_weight_out_kgs',
      source_column_name: 'avg_wt_out',
      column_not_used: 'Used (0)',
    },
    {
      column_number: 36,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'date',
      target_column_name: 'csb_pl_avg_date_in',
      source_column_name: 'avg_date_in',
      column_not_used: 'Used (0)',
    },
    {
      column_number: 37,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'date',
      target_column_name: 'csb_pl_avg_date_out',
      source_column_name: 'avg_date_out',
      column_not_used: 'Used (0)',
    },
    {
      column_number: 38,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'numeric',
      target_column_name: 'csb_pl_total_days_on_feed',
      source_column_name: 'dof',
      column_not_used: 'Used (0)',
    },
    {
      column_number: 39,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'numeric',
      target_column_name: 'csb_pl_total_head_days',
      source_column_name: 'hddays',
      column_not_used: 'Used (0)',
    },
    {
      column_number: 40,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'varchar',
      target_column_name: 'csb_pl_notes',
      source_column_name: 'csb_pl_notes',
      column_not_used: 'Not Used (1)',
    },
  ];

  // Data for the Drug Template Fields table
  const drugTemplateFields = [
    {
      column_number: 1,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'bigint',
      target_column_name: 'csb_survey_production_lot_drug_id',
      source_column_name: 'csb_survey_production_lot_drug_id',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 2,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'bigint',
      target_column_name: 'csb_survey_production_lot_id',
      source_column_name: 'csb_survey_production_lot_id',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 3,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'bigint',
      target_column_name: 'csb_survey_main_id',
      source_column_name: 'csb_survey_main_id',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 4,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'bigint',
      target_column_name: 'csb_record_group_id',
      source_column_name: 'csb_record_group_id',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 5,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'bigint',
      target_column_name: 'csb_account_id',
      source_column_name: 'csb_account_id',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 6,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'bigint',
      target_column_name: 'csb_survey_production_lot_upload_id',
      source_column_name: 'csb_survey_production_lot_upload_id',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 7,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'integer',
      target_column_name: 'csb_pl_template_id',
      source_column_name: 'csb_pl_template_id',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 8,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'integer',
      target_column_name: 'csb_pl_drug_ordinal',
      source_column_name: 'csb_pl_drug_ordinal',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 9,
      target_column_classify_field_setup: 'Setup Lookup Field (2)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'integer',
      target_column_name: 'csb_pl_drug_route_id',
      source_column_name: 'route',
      column_not_used: 'Used (0)',
    },
    {
      column_number: 10,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'varchar(192)',
      target_column_name: 'csb_pl_source_drug_name',
      source_column_name: 'active_ingredient',
      column_not_used: 'Used (0)',
    },
    {
      column_number: 11,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'numeric',
      target_column_name: 'csb_pl_source_drug_value',
      source_column_name: 'final_active_ingredient_amount',
      column_not_used: 'Used (0)',
    },
    {
      column_number: 12,
      target_column_classify_field_setup: 'Setup Lookup Field (2)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'integer',
      target_column_name: 'csb_pl_source_drug_value_units_id',
      source_column_name: 'unit',
      column_not_used: 'Used (0)',
    },
    {
      column_number: 13,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Trade Name (2)',
      target_column_type: 'integer',
      target_column_name: 'csb_pl_drug_trade_name_id (TnId=)',
      source_column_name: 'product',
      column_not_used: 'Used (0)',
    },
    {
      column_number: 14,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Active Ingredient (1)',
      target_column_type: 'integer',
      target_column_name: 'csb_pl_drug_active_ingredient_id (AiId=)',
      source_column_name: 'active_ingredient',
      column_not_used: 'Used (0)',
    },
    {
      column_number: 15,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'numeric',
      target_column_name: 'csb_pl_drug_total_mg',
      source_column_name: 'final_active_ingredient_amount',
      column_not_used: 'Used (0)',
    },
    {
      column_number: 16,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'numeric',
      target_column_name: 'csb_pl_drug_total_ml',
      source_column_name: 'csb_pl_drug_total_ml',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 17,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'bigint',
      target_column_name: 'csb_pl_drug_regimen_id',
      source_column_name: 'csb_pl_drug_regimen_id',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 18,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'bigint',
      target_column_name: 'csb_pl_drug_regimen_detail_id',
      source_column_name: 'csb_pl_drug_regimen_detail_id',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 19,
      target_column_classify_field_setup: 'Setup Lookup Field (2)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'integer',
      target_column_name: 'csb_pl_drug_primary_reason_for_use',
      source_column_name: 'reason_for_use',
      column_not_used: 'Used (0)',
    },
    {
      column_number: 20,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'numeric',
      target_column_name: 'csb_pl_drug_primary_reason_for_use_pct_gp',
      source_column_name: 'csb_pl_drug_primary_reason_for_use_pc',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 21,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'numeric',
      target_column_name: 'csb_pl_drug_primary_reason_for_use_pct_dp',
      source_column_name: 'csb_pl_drug_primary_reason_for_use_pc',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 22,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'numeric',
      target_column_name: 'csb_pl_drug_primary_reason_for_use_pct_dt',
      source_column_name: 'csb_pl_drug_primary_reason_for_use_pc',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 23,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'integer',
      target_column_name: 'csb_pl_drug_secondary_reason_respiratory',
      source_column_name: 'condition',
      column_not_used: 'Used (0)',
    },
    {
      column_number: 24,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'integer',
      target_column_name: 'csb_pl_drug_secondary_reason_digestive',
      source_column_name: 'condition',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 25,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'integer',
      target_column_name: 'csb_pl_drug_secondary_reason_lameness',
      source_column_name: 'condition',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 26,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'integer',
      target_column_name: 'csb_pl_drug_secondary_reason_neurologic',
      source_column_name: 'condition',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 27,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'integer',
      target_column_name: 'csb_pl_drug_secondary_reason_liver_abscess',
      source_column_name: 'condition',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 28,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'integer',
      target_column_name: 'csb_pl_drug_secondary_reason_coccidiosis',
      source_column_name: 'condition',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 29,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'integer',
      target_column_name: 'csb_pl_drug_secondary_reason_enteritis',
      source_column_name: 'condition',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 30,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'integer',
      target_column_name: 'csb_pl_drug_secondary_reason_mixed',
      source_column_name: 'condition',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 31,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'varchar(128)',
      target_column_name: 'csb_pl_drug_secondary_reason_mixed_description',
      source_column_name: 'condition',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 32,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'integer',
      target_column_name: 'csb_pl_drug_secondary_reason_other',
      source_column_name: 'condition',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 33,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'varchar(128)',
      target_column_name: 'csb_pl_drug_secondary_reason_other_description',
      source_column_name: 'condition',
      column_not_used: 'Not Used (1)',
    },
    {
      column_number: 34,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'varchar',
      target_column_name: 'csb_pl_drug_secondary_reason_source',
      source_column_name: 'condition',
      column_not_used: 'Used (0)',
    },
    {
      column_number: 35,
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      target_field_category: 'Core Field (0)',
      target_column_type: 'varchar',
      target_column_name: 'csb_pl_drug_notes',
      source_column_name: 'csb_pl_drug_notes',
      column_not_used: 'Not Used (1)',
    },
  ];

  return (
    <Container>
      <Section>
        <Heading>
          Production Lot Upload Data Preparation: Coaldale Veterinary Clinic (CVC)
          <br />
          Site Information Details
        </Heading>
        <Paragraph>Coaldale Veterinary Clinic (3) (CVC)</Paragraph>
        <Paragraph>Vet: CSBV00004 (4)</Paragraph>
        <Paragraph>Project Year: 2022</Paragraph>
        <Paragraph>The site has seven (7) herds. They are:</Paragraph>
        <List>
          <ListItem>CSBH0000030</ListItem>
          <ListItem>CSBH0000031</ListItem>
          <ListItem>CSBH0000032</ListItem>
          <ListItem>CSBH0000033</ListItem>
          <ListItem>CSBH0000050</ListItem>
          <ListItem>CSBH0000051</ListItem>
          <ListItem>CSBH0000052</ListItem>
        </List>
        <Paragraph>Access to previous years documentation click on the appropriate link below:</Paragraph>
        <List>
          <CleanList><Link to="/beef/data-preparation/cvc2019">CVC 2019</Link></CleanList>
          <CleanList><Link to="/beef/data-preparation/cvc2020">CVC 2020</Link></CleanList>
          <CleanList><Link to="/beef/data-preparation/cvc2021">CVC 2021</Link></CleanList>
          <CleanList><Link to="/beef/data-preparation/cvc2023">CVC 2023</Link></CleanList>
          <CleanList><Link to="/beef/data-preparation/cvc2024">CVC 2024</Link></CleanList>
        </List>
      </Section>

      <Section>
        <Heading>
          Production Lot Upload Data Preparation: Coaldale Veterinary Clinic (CVC)
          <br />
          Data Source Information
        </Heading>
        <Paragraph>CVC has 7 herds for 2022.</Paragraph>
        <Paragraph>Each spreadsheet/workbook from CVC represents all herds for a specific sampling year.</Paragraph>
        <Paragraph>The core fields in a sheet have drug fields listed at the end of the core field data.</Paragraph>
        <Paragraph>The drugs are listed as rows, not columns, within the sheet.</Paragraph>

        <Paragraph><Strong>Core field data is repeated for each associated row of drug information.</Strong></Paragraph>
        <Paragraph>However, the repeated core field data is implied, meaning core field information has 1 row filled in, the remaining rows are blank until you switch to a different production lot.</Paragraph>
        <Paragraph>During the upload of the spreadsheet into the database, missing or implied core field data is filled in.</Paragraph>

        <Paragraph><Strong>A new column is to be added to the source spreadsheet. The column name is called "change_to_rows".</Strong></Paragraph>
        <Paragraph>As the name implies, insert the column where the core data as columns of information, changes to drug information which are rows of data. Each value in the "change_to_rows" column is "&lt;&lt;row&gt;&gt;". When it is setup in this way the program to upload the data knows where column data changes to row based data for the drugs.</Paragraph>

        <Paragraph><Strong>The rows of drug data represent 1 drug, usually a product name and active ingredient for 1 drug route.</Strong></Paragraph>
        <Paragraph>The product name in the target database is called a trade name. The combination of both trade name and active ingredient are used in combination to acquire the correct trade name id and active ingredient id. What is new for 2020 is each row in the source spreadsheet with a product name and active ingredient needs to be checked.</Paragraph>
        <Paragraph>What is done is to make certain the trade name has 1 and only 1 active ingredient associated with it. If not, then the upload takes into account and uploads the multiple active ingredients associated with the specific trade name.</Paragraph>
        <Paragraph>All drug routes and associated drugs for a production lot are available.</Paragraph>

        <Paragraph><Strong>There are several extra things you should do in the spreadsheet before uploading the data:</Strong></Paragraph>
        <Paragraph>The <Strong>season</Strong> or "<Strong>closeout</Strong>" field is not added and needs to be calculated.</Paragraph>
        <Paragraph>Define season using the <Strong>Average Date Out</Strong> field in the following way:</Paragraph>
        <List>
          <ListItem>Winter &rarr; January 1 thru March 31</ListItem>
          <ListItem>Spring &rarr; April 1 thru June 30</ListItem>
          <ListItem>Summer &rarr; July 1 thru September 30</ListItem>
          <ListItem>Fall &rarr; October 1 thru December 31</ListItem>
        </List>

        <Paragraph>The <Strong>days on feed</Strong> field needs to be calculated.</Paragraph>
        <Paragraph>Define days on feed &rarr; Average Date Out minus (-) Average Date In</Paragraph>

        <Paragraph><Strong>Make sure to format all date columns as "date" in the spreadsheet.</Strong> When uploading into the database the data table will take on the date format as expected. If you do not do this it appears it is less reliable to pickup we have a date.</Paragraph>

        <Paragraph>Before creating and setting up a template, go thru all spreadsheets provided from the site.</Paragraph>
        <Paragraph>Collect field names from each site and put them together. Review the field names to make sure they all match. My experience is the field names do not match. To reduce the number of templates to create, get the field names to match. The fields do not need to be in the same order.</Paragraph>
        <Paragraph>For the 2020 CVC data all feeds are the same. Only a few new columns were added to complete the data for upload.</Paragraph>
      </Section>

      ---

      <Section>
        <Heading>
          Production Lot Upload Data Preparation: Coaldale Veterinary Clinic (CVC)
          <br />
          Template Setup Suggestions
        </Heading>
        <Paragraph>A two template setup is used for one or more years batch of data.</Paragraph>
        <Paragraph>For the current document, assume we place all known drug fields for all drug routes at the end of the core fields.</Paragraph>
        <Paragraph>Since the data switches from Core field columns to Drug fields as rows we insert a field in the spreadsheet</Paragraph>
        <Paragraph>The field is called "<Strong>change_to_rows</Strong>". It is a column header in the spreadsheet and a field name in the uploaded data table.</Paragraph>
        <Paragraph>When we do this, the primary, top level template created represents the Core fields.</Paragraph>
        <Paragraph>The secondary, second level child template created represents the Drug fields associated with a Core row of data.</Paragraph>

        <Paragraph>The Core Template is populated from the Target Table from the production lot table (core fields).</Paragraph>
        <Paragraph>The Child Drug Template is populated from the Target Table from the drug table (drug fields).</Paragraph>

        <Paragraph>When preparing to do the final integrate of CVC data, after the uploaded data has been checked, from the check history, select the row where the core data has been checked.</Paragraph>
        <Paragraph>Here are the typical template settings used for CVC.</Paragraph>
        <List>
          <ListItem><Strong>Name:</Strong> CVC 2022 - Core All Herds</ListItem>
          <ListItem><Strong>Level:</Strong> Top Level (1)</ListItem>
          <ListItem><Strong>Type:</Strong> Core (1)</ListItem>
          <ListItem><Strong>Route:</Strong> Multiple Drugs (4)</ListItem>
          <ListItem><Strong>Version:</Strong> Version 2 (2)</ListItem>
          <ListItem><Strong>By Row or Column:</Strong> By Column (2)</ListItem>
          <ListItem><Strong>Method:</Strong> Populate template fields from Target (1)</ListItem>
        </List>
        <Image src="/images/ss_template_cvc_core_2022.png"/>
      </Section>

      <TemplateFieldsTable
        title="Core Template: Associated Core Template Fields"
        fields={coreTemplateFields}
      />

      <Section>
        <List>
          <ListItem><Strong>Name:</Strong> CVC 2022 - Drugs All Herds</ListItem>
          <ListItem><Strong>Level:</Strong> Second Level (2)</ListItem>
          <ListItem><Strong>Type:</Strong> Drug (2)</ListItem>
          <ListItem><Strong>Route:</Strong> Multiple Drugs (4)</ListItem>
          <ListItem><Strong>Version:</Strong> Version 1 (1)</ListItem>
          <ListItem><Strong>By Row or Column:</Strong> By Row (1)</ListItem>
          <ListItem><Strong>Method:</Strong> Populate template fields from Target (1)</ListItem>
        </List>
        <Image src="/images/ss_template_cvc_drug_2022.png"/>
      </Section>

      <TemplateFieldsTable
        title="Drug Template: Associated Template Fields"
        fields={drugTemplateFields}
      />
    </Container>
  );
};

export default Cvc2022Content;